import React from 'react';
import './Maintenance.css';

const Maintenance = () => {
  return (
    <div className="maintenance-container">
      <h1>Under Maintenance</h1>
      <p>Our updates page is currently under maintenance. Please check back later.</p>
    </div>
  );
};

export default Maintenance; 